export enum PageError {
  BOOK_NOT_FOUND = "book-not-found",
  PAGE_NOT_FOUND = "page-not-found",
  BOOK_REBUILDING = "book-rebuilding",
  BOOK_NOT_ACTIVATED = "book-not-activated",
  LOGGED_OUT = "logged-out",
  ACCESS_DENIED = "access-denied",
  BOT_DETECTED = "bot-detected", // e.g. distil, old-style recaptcha
  BROWSER_NOT_SUPPORTED = "browser-not-supported",
  UNKNOWN = "unknown",
}
